import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyAllReportsRoute: InvariantJiraRoute = {
	name: 'legacy-all-reports',
	path: '/projects/:projectKey',
	query: ['selectedItem=(.*report-page.*)'],
};
